import { styled } from '@mui/material/styles';

const decideBorderColor = ({ status, theme }) => {
  switch (status) {
    case 'new':
      return theme.colors.neutral.shades.shade300;
    case 'in progress':
      return theme.colors.yellow.shades.shade500;
    case 'done':
      return theme.colors.green.shades.shade600;
    default:
      return theme.colors.neutral.shades.shade300;
  }
}

const decideTextColor = ({ status, theme }) => {
  switch (status) {
    case 'new':
      return theme.colors.neutral.shades.shade500;
    case 'in progress':
      return theme.colors.yellow.shades.shade500;
    case 'done':
      return theme.colors.white;
    default:
      return theme.colors.neutral.shades.shade500;
  }
}

export const SurveyProgressWrapper = styled('div')`
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection};
  align-items: center;
  padding: 24px;
  gap: 24px;
  width: 100%;
  min-height: 128px;
  background: ${({ cardBackground }) => cardBackground};
  border-radius: 8px;
  margin-bottom: 24px;
`;

export const IconWrapper = styled('div') <{ status: string }>`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ status, theme }) => status === 'done' ? theme.colors.green.shades.shade600 : theme.colors.white};
  border-radius: 50%;
  border: ${({ status, theme }) => `2px solid ${decideBorderColor({ status, theme })}`};
  color: ${({ status, theme }) => decideTextColor({ status, theme })};
  border-color:${({ status, theme }) => status === 'in progress' ?
    `${theme.colors.yellow.shades.shade500} ${theme.colors.yellow.shades.shade500} ${theme.colors.yellow.shades.shade100} ${theme.colors.yellow.shades.shade100}` :
    status === 'done' ? '' : theme.colors.neutral.shades.shade300};
`;

export const ButtonGroup = styled('div')`
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection};
  flex-direction: ${({ alignItems }) => alignItems};
  gap: 8px;
  justify-content: flex-end;
`;

function getRotation(percentage: number) {
  let deg = Math.floor(Math.floor(percentage) * 3.6);

  if (deg < 190) {
    return `
          linear-gradient(${deg - 90}deg, #FEE8C7 50%, transparent 50%),
          linear-gradient(to right, #FEE8C7 50%, #D98506 50%)
      `;
  } if (deg > 170) {
    return `
          linear-gradient(${deg + 90}deg, #D98506 50%, transparent 50%),
          linear-gradient(to right, #FEE8C7 50%, #D98506 50%)
    `;
  } else {
    return `
          linear-gradient(${deg-180}deg, #D98506 50%, transparent 50%),
          linear-gradient(to right, #FEE8C7 50%, #D98506 50%)
      `;
  }
}

export const CircleChart = styled('div') <{ percentage: string }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-image: ${({ percentage }) => getRotation(percentage)};
  line-height: 40px;
  text-align: center;
  font-size: 12px;
  position: relative;
  border-radius: 50%;
  background-origin: border-box;
    &::after {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    right: 2px;
    bottom: 2px;
    border-radius: 50%;
    background: white;
  }
`;

export const CircleContent = styled('div')`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  height: 40px;
`;